import React, { useState, useEffect } from 'react';
import '../../assets/css/checklist.css';
import { format } from 'date-fns';
import Grid from '@material-ui/core/Grid';
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { ProgressSpinner } from 'primereact/progressspinner';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { dominioLeanAspNetAPI } from '../../config/database';

export default function Checklist(props) {
  const [checklist, setChecklist] = useState(null);
  const [profissional, setProfissional] = useState(
    JSON.parse(localStorage.getItem('profissional'))
  );
  const [carregar, setCarregar] = useState(false);
  const [abreDialog, setAbreDialog] = useState(false);
  const [tituloDialog, setTituloDialog] = useState('');
  const [textoDialog, setTextoDialog] = useState('');
  const [acaoConfirmacaoDialog, setAcaoConfirmacaoDialog] = useState(() => { });

  const handleSubmit = e => {
    e.preventDefault();
  };

  const handleClickDesmarcar = stringProcesso => {
    let checklistAtualizado;

    if (stringProcesso === 'desmarcarEpicriseRecebida') {
      checklistAtualizado = {
        ...checklist,
        datEpicriseRecebida: null,
        profEpicriseRecebida: null,
      };
    }
    if (stringProcesso === 'desmarcarServicoSocial') {
      checklistAtualizado = {
        ...checklist,
        datServicoSocial: null,
        profServicoSocial: null,
      };
    }
    if (stringProcesso === 'desmarcarTransporte') {
      checklistAtualizado = {
        ...checklist,
        datSolicitacaoTransporte: null,
        profSolicitacaoTransporte: null,
      };
    }
    if (stringProcesso === 'desmarcarHigiene') {
      checklistAtualizado = {
        ...checklist,
        datHigiene: null,
        profHigiene: null,
      };
    }
    if (stringProcesso === 'desmarcarLeitoLimpo') {
      checklistAtualizado = {
        ...checklist,
        datLeitoLimpo: null,
        profLeitoLimpo: null,
      };
    }

    setChecklist(checklistAtualizado);

    props.setInternacao({
      ...props.internacao,
      checklist: checklistAtualizado,
    });

    const data = {
      seqInternacao: props.internacao.seqInternacao,
      idProfissional: profissional.idProfissional,
      seqLeito: props.leito.seqLeito,
    };
    dominioLeanAspNetAPI.put(`/api/${stringProcesso}`, data);
  };

  const marcarItemChecklist = async (checklistAtualizado, stringProcesso) => {
    const data = {
      seqInternacao: props.internacao.seqInternacao,
      idProfissional: profissional.idProfissional,
      seqLeito: props.leito.seqLeito,
    };

    await dominioLeanAspNetAPI.put(`/api/${stringProcesso}`, data);

    setChecklist(checklistAtualizado);
    props.setInternacao({ ...props.internacao, checklistAtualizado });
  };

  const handleAbreDialog = (titulo, texto, acaoConfirmacao) => {
    setTituloDialog(titulo);
    setTextoDialog(texto);
    setAbreDialog(true);
    setAcaoConfirmacaoDialog(() => acaoConfirmacao);
  };

  const renderAcao = (dataAcao, stringProcesso) => {
    if (!profissional?.permissaoNIR) return null;

    let opcao = '';

    switch (stringProcesso) {
      case 'desmarcarEpicriseRecebida':
        if (checklist?.datHigiene && dataAcao)
          return (
            <Grid item xs={2} sm={2}>
              <IconButton
                style={{ height: '2.5vw', width: '100%' }}
                onClick={() => {
                  handleAbreDialog(
                    'Atenção',
                    `Para limpar os dados da Epicrise Recebida é necessário que a Higiene não esteja checada.`,
                    null
                  );
                }}
              >
                <DeleteForeverIcon />
              </IconButton>
            </Grid>
          );
        opcao = 'Epicrise Recebida';
        break;
      case 'desmarcarServicoSocial':
        if (checklist?.datSolicitacaoTransporte && dataAcao)
          return (
            <Grid item xs={2} sm={2}>
              <IconButton
                style={{ height: '2.5vw', width: '100%' }}
                onClick={() => {
                  handleAbreDialog(
                    'Atenção',
                    `Para limpar os dados do Serviço Social é necessário que a Solicitação Transporte não esteja checada.`,
                    null
                  );
                }}
              >
                <DeleteForeverIcon />
              </IconButton>
            </Grid>
          );
        opcao = 'Servico Social';
        break;
      case 'desmarcarTransporte':
        opcao = 'Transporte';
        break;
      case 'desmarcarHigiene':
        if (checklist?.datLeitoLimpo && dataAcao)
          return (
            <Grid item xs={2} sm={2}>
              <IconButton
                style={{ height: '2.5vw', width: '100%' }}
                onClick={() => {
                  handleAbreDialog(
                    'Atenção',
                    `Para limpar os dados da Higiene é necessário que o Leito Limpo não esteja checado.`,
                    null
                  );
                }}
              >
                <DeleteForeverIcon />
              </IconButton>
            </Grid>
          );
        opcao = 'Higiene';
        break;
      case 'desmarcarLeitoLimpo':
        opcao = 'Leito Limpo';
        break;
      default:
        opcao = '';
    }

    if (dataAcao)
      return (
        <Grid item xs={2} sm={2}>
          <IconButton
            style={{ height: '2.5vw', width: '100%' }}
            onClick={() => {
              handleAbreDialog('Atenção', `Deseja limpar o registro da opção ${opcao}?`, () => {
                handleClickDesmarcar(stringProcesso);
              });
            }}
          >
            <DeleteForeverIcon />
          </IconButton>
        </Grid>
      );

    return (
      <Grid item xs={2} sm={2}>
        <Typography className="acoes">SEM AÇÕES</Typography>
      </Grid>
    );
  };

  const renderAcaoCabecalho = () => {
    if (!profissional?.permissaoNIR) return null;

    return (
      <Grid item xs={2} sm={2}>
        <Typography className="acoes-titulo nome-campo">AÇÕES</Typography>
      </Grid>
    );
  };

  useEffect(() => {
    setCarregar(true);
    setChecklist(props.checklist);
    setCarregar(false);
  }, []);

  const handleFechaDialog = () => {
    setAbreDialog(false);
  };

  if (carregar) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <>
      <Dialog
        open={abreDialog}
        onClose={handleFechaDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{tituloDialog}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{textoDialog}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFechaDialog}>Voltar</Button>
          {acaoConfirmacaoDialog ? (
            <Button
              onClick={() => {
                acaoConfirmacaoDialog();
                handleFechaDialog();
              }}
              autoFocus
            >
              Confirmar
            </Button>
          ) : null}
        </DialogActions>
      </Dialog>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <Typography className="processos nome-campo">PROCESSOS</Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check nome-campo">DATA/HORA</Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional nome-campo">PROFISSIONAL</Typography>
          </Grid>
          {renderAcaoCabecalho()}
          <br />
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              disabled
              control={<Checkbox checked={checklist && checklist.datEpicriseEfetuada} />}
              label="Epicrise Efetuada"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datEpicriseEfetuada
                ? format(new Date(checklist.datEpicriseEfetuada), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profEpicriseEfetuada : undefined}
            </Typography>
          </Grid>
          {renderAcao(null)}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checklist && checklist.datEpicriseRecebida}
                  disabled={
                    (checklist && checklist.datEpicriseRecebida) || props.leito.cor === '#8947B3'
                  }
                  onChange={() => {
                    handleAbreDialog('Atenção', 'Deseja checar a opção epicrise recebida?', () => {
                      marcarItemChecklist(
                        {
                          ...checklist,
                          datEpicriseRecebida: new Date().toISOString(),
                          profEpicriseRecebida: profissional.nomeProfissional,
                        },
                        'marcarEpicriseRecebida'
                      );
                    });
                  }}
                />
              }
              label="Epicrise Recebida"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datEpicriseRecebida
                ? format(new Date(checklist.datEpicriseRecebida), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profEpicriseRecebida : undefined}
            </Typography>
          </Grid>
          {renderAcao(checklist?.datEpicriseRecebida, 'desmarcarEpicriseRecebida')}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checklist && checklist.datServicoSocial}
                  disabled={
                    (checklist && checklist.datServicoSocial) || props.leito.cor === '#8947B3'
                  }
                  onChange={() => {
                    handleAbreDialog('Atenção', 'Deseja checar a opção serviço social?', () => {
                      marcarItemChecklist(
                        {
                          ...checklist,
                          datServicoSocial: new Date().toISOString(),
                          profServicoSocial: profissional.nomeProfissional,
                        },
                        'marcarServicoSocial'
                      );
                    });
                  }}
                />
              }
              label="Solicitação Serviço Social"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datServicoSocial
                ? format(new Date(checklist.datServicoSocial), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profServicoSocial : undefined}
            </Typography>
          </Grid>
          {renderAcao(checklist?.datServicoSocial, 'desmarcarServicoSocial')}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checklist && checklist.datSolicitacaoTransporte}
                  disabled={
                    (checklist && checklist.datSolicitacaoTransporte) ||
                    props.leito.cor === '#8947B3'
                  }
                  onChange={() => {
                    handleAbreDialog(
                      'Atenção',
                      'Deseja checar a opção solicitação do transporte?',
                      () => {
                        marcarItemChecklist(
                          {
                            ...checklist,
                            datSolicitacaoTransporte: new Date().toISOString(),
                            profSolicitacaoTransporte: profissional.nomeProfissional,
                          },
                          'marcarTransporte'
                        );
                      }
                    );
                  }}
                />
              }
              label="Solicitação Transporte"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datSolicitacaoTransporte
                ? format(new Date(checklist.datSolicitacaoTransporte), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profSolicitacaoTransporte : undefined}
            </Typography>
          </Grid>
          {renderAcao(checklist?.datSolicitacaoTransporte, 'desmarcarTransporte')}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              disabled
              control={<Checkbox checked={checklist && checklist.datSaida} />}
              label="Saída da Recepção"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datSaida
                ? format(new Date(checklist.datSaida), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profSaida : undefined}
            </Typography>
          </Grid>
          {renderAcao(null)}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checklist && checklist.datHigiene}
                  disabled={(checklist && checklist.datHigiene) || props.leito.cor !== '#8947B3'}
                  onChange={() => {
                    handleAbreDialog('Atenção', 'Deseja checar a opção higiene?', () => {
                      marcarItemChecklist(
                        {
                          ...checklist,
                          datHigiene: new Date().toISOString(),
                          profHigiene: profissional.nomeProfissional,
                        },
                        'marcarHigiene'
                      );
                    });
                  }}
                />
              }
              label="Solicitação Higiene"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datHigiene
                ? format(new Date(checklist.datHigiene), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profHigiene : undefined}
            </Typography>
          </Grid>
          {renderAcao(checklist?.datHigiene, 'desmarcarHigiene')}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={3} sm={3} className="right-border">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checklist && checklist.datLeitoLimpo}
                  disabled={
                    (checklist && checklist.datLeitoLimpo) ||
                    props.leito.cor !== '#8947B3' ||
                    !(checklist && checklist.datHigiene)
                  }
                  onChange={() => {
                    handleAbreDialog('Atenção', 'Deseja realmente confirmar?', async () => {
                      await marcarItemChecklist(
                        {
                          ...checklist,
                          datLeitoLimpo: new Date().toISOString(),
                          profLeitoLimpo: profissional.nomeProfissional,
                        },
                        'marcarLeitoLimpo'
                      );
                      props.voltarMapaLeito();
                    });
                  }}
                />
              }
              label="Leito Limpo"
            />
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 2 : 3}
            sm={profissional?.permissaoNIR ? 2 : 3}
            className="right-border"
          >
            <Typography className="data-hora-check">
              {checklist && checklist.datLeitoLimpo
                ? format(new Date(checklist.datLeitoLimpo), 'dd/MM/yyyy - HH:mm')
                : undefined}
            </Typography>
          </Grid>
          <Grid
            item
            xs={profissional?.permissaoNIR ? 5 : 6}
            sm={profissional?.permissaoNIR ? 5 : 6}
            className={profissional?.permissaoNIR ? 'right-border' : ''}
          >
            <Typography className="profissional">
              {checklist ? checklist.profLeitoLimpo : undefined}
            </Typography>
          </Grid>
          {renderAcao(checklist?.datLeitoLimpo, 'desmarcarLeitoLimpo')}
        </Grid>
      </form>
    </>
  );
}
